import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';
import View_User_Data from 'view/user_data';
import Collection_Survey_Question from 'collection/survey_question';
import responseSessionTemplate from 'template/survey/response_session';

export default View.extend({
    className: 'survey-response-inbox-preview',

    views: {
        user_data: null,
    },

    loadQuestions: function() {
        Cache.app.request({
            action: 'survey/loadQuestions',
            data: {
                project_id: this.model.get('project_id')
            },
            success: (response) => {
                var collection = new Collection_Survey_Question(response);
                this.questions = collection.filter((model) => {
                    return ['welcome', 'thankyou'].indexOf(model.get('question_type')) === -1;
                });

                this.views.user_data = new View_User_Data({
                    model: this.model,
                    identification : this.model.get('user_identification'),
                    sidebar: true,
                });

                this.render();
            }
        });
    },

    initialize: function(options) {
        if (this.questions) {
            this.views.user_data = new View_User_Data({
                model: this.model,
                identification : this.model.get('user_identification'),
                sidebar: true,
            });
        }
    },

    render: function() {
        var questions = '';

        if (this.questions) {
            this.questions.forEach((question) => {
                questions +=
                '<div>' +
                    '<div class="margin-bottom-4 text-info">' + question.getLabel(true) + '</div>' +
                    '<div>' + (this.model.renderAnswer(question, true) || '-') + '</div>' +
                '</div>';
            });
        }

        var custom_data = this.model.get('custom_data');
        var custom_data_items = '';

        Object.entries(custom_data).forEach(([label, data]) => {
            custom_data_items +=
            '<div class="title" title="' + Util.htmlEntities(label) + '">' + Util.htmlEntitiesWithA(label) + ':</div>' +
            '<div class="value">' + (Util.htmlEntitiesWithA(data, true) || '-') + '</div>';
        });

        var content =
        '<div class="badge-id margin-bottom-12">' + this.model.id + '</div>' +
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#" class="active">Response</a>' +
                '<a href="#">Session</a>' +
            '</div>' +

            '<div class="tab-content">' +
                '<div class="box-neutral-light active">' +
                    (this.questions ?
                    '<div class="grid-gap-16">' + questions + '</div>':
                    '<div class="loader-placeholder-small margin-bottom-4"></div>' +
                    '<div class="loader-placeholder-small margin-bottom-16" style="width:30%;"></div>' +
                    '<div class="loader-placeholder-small margin-bottom-4"></div>' +
                    '<div class="loader-placeholder-small" style="width:30%;"></div>') +
                '</div>' +
                '<div>' +
                    '<div class="region-session-details">' +
                        '<div class="item-header">Metadata</div>' +
                        '<div class="session-data-panel box-neutral-light">' +
                            responseSessionTemplate(this.model) +
                        '</div>' +
                    '</div>' +

                    '<div class="region-user-data"></div>' +

                    '<div class="region-custom-data">' +
                        '<div class="item-header">Custom Data</div>' +
                        '<div class="custom-data-panel box-neutral-light">' +
                            (custom_data_items ?
                            '<div class="item-content">' + custom_data_items + '</div>' :
                            '<div class="text-info italic">No custom data captured. <a target="help" rel="noopener" href="https://docs.userback.io/docs/attach-custom-data">Find out more</a>.</div>') +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (this.views.user_data instanceof View_User_Data) {
            this.views.user_data.render().$el.appendTo(this.$el.find('.region-user-data'));
        }

        if (!this.questions) {
            this.loadQuestions();
        }

        return this;
    }
});